import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useUserTabs } from '../common/UserTabsContext';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import './Notifications.css';
import { fetchNotifications, updateNotifications, endCNBreak } from "../../../../services/cn/Service";

const Notifications = (props) => {
    const handleShowUnreadDot = props.handleShowUnreadDot ? props.handleShowUnreadDot : console.log("props.handleShowUnreadDot not found");

    const [notifications, setNotifications] = useState([]);
    const { addUserTab } = useUserTabs();

    const [breakId, setBreakId] = useState("");
    const [breakEnd, setBreakEnd] = useState("");
    const [showBreakModal, setShowBreakModal] = useState(false);

    const handleUserClick = (user) => {
        addUserTab(user);
    };

    useEffect(() => {
        getNotifications();
        const interval = setInterval(() => {
            getNotifications();
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    const getNotifications = async () => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await fetchNotifications(ct)
            .then((response) => {
                if (response.data.code === 200) {
                    if (response.data.data.breaks.length > 0) {
                        setBreakId(response.data.data.breaks[0].breakId);
                        setBreakEnd(response.data.data.breaks[0].breakEnd)
                        setShowBreakModal(true);
                    }
                    setNotifications(response.data.data.notifications);
                    handleShowUnreadDot(response.data.data.showUnreadDot, response.data.data.unreadNotificationCount);
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const updateNotificationAction = async (notificationId, userInfo, action) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await updateNotifications(notificationId, action, ct)
            .then((response) => {
                setNotifications([])
                if (action === "actiontaken") {
                    handleUserClick({ userId: userInfo.userId, name: userInfo.memberName });
                }
                //getNotifications();
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }

    const handleEndBreakAction = (breakId) => {
        alertify.confirm(`Confirm Break End`, `Are you sure you want to end the break?`, () => {
            endBreakAction(breakId);
        }, () => {
        }).set('modal', true).set('movable', false);
    }

    const endBreakAction = async (breakId) => {
        const request = axios.CancelToken.source();
        let ct = {
            cancelToken: request.token
        }
        await endCNBreak(breakId, ct)
            .then((response) => {
                if (response.data.code === 200) {
                    setShowBreakModal(false);
                    setBreakId("");
                    setBreakEnd("");
                }
            }).catch(function (error) {
                console.log(error);
            });
        return () => request.cancel();
    }



    return (

        <>
            {
                (notifications.length > 0) ?
                    <div className='notificationDiv'>
                        <Row>
                            <Col>
                                {notifications.map((notification, index) => (
                                    <div key={index} className='row align-items-center'>
                                        <div className='col-auto'>
                                            <span className='bellContainer'><i className="fa fa-bell" aria-hidden="true"></i></span>
                                        </div>
                                        <div className='col px-1 notificationTitle'>
                                            {notification.notificationText}
                                        </div>
                                        <div className='col-auto'>
                                            {
                                                <>
                                                    <span>
                                                        {' '}
                                                        <Link to={'/members/' + encodeURIComponent(notification.userId, "UTF-8")} className='name' onClick={() => {
                                                            updateNotificationAction(notification.notificationId, notification, 'actiontaken');

                                                        }}>{' '}
                                                            <button class="btn btn-primary save-btn">View Profile</button>
                                                        </Link>{' '}
                                                        <button class="btn notification-btn-closs ms-2" onClick={() => {
                                                            updateNotificationAction(notification.notificationId, notification, 'alertdismissed')
                                                        }}> <i className="bi bi-x-lg" aria-hidden="true"></i></button>

                                                    </span>
                                                </>
                                            }
                                        </div>



                                    </div>
                                ))}
                            </Col>
                        </Row>
                    </div > : ""
            }

            <Modal id="cnBreakBlocker" size="" backdrop="static" keyboard={false} show={showBreakModal} centered>
                <Modal.Header>
                    <Modal.Title>You are on a break!</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="mb-3 tw-text-center">Your break ends on {breakEnd}.<br/>End it first before resuming work.</p>
                    <div className="d-flex justify-content-center">
                        <button className="btn btn-primary save-btn" onClick={() => handleEndBreakAction(breakId)}>
                            End Now
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <style jsx={true}>
                {`
                    .alertify .ajs-dialog {
                        top: 50% !important;
                        left: 50% !important;
                        transform: translate(-50%, -50%) !important;
                        margin: 0 !important;
                    }
                `}
            </style>
        </>

    );
};

export default Notifications;